import {initAccordions} from "./accordion";
import {initLicense} from "./license";
import {initDomainManager} from "./domain-manager";
import {initTooltip} from "./tooltip";
import {initRepeaterFields} from "./repeater-field";
import {initDashboard} from "./dashbaord";

const initWpSmsScript = () => {
    initAccordions()
    initLicense()
    initDomainManager()
    initTooltip()
    initRepeaterFields()
    initDashboard()
}

initWpSmsScript();